import React, { useRef, useState } from "react";
import "./Residence.css";
import videoPoster from "../../assets/img/poster.jpg";
import historyVideoPoster from "../../assets/img/preview_history_vid.jpg";
import residenceImg from "../../assets/img/residence_card1.jpg";
import old1 from "../../assets/img/residence/old_1.JPG";
import old2 from "../../assets/img/residence/old_2.JPG";
import old3 from "../../assets/img/residence/old_3.JPG";
import old4 from "../../assets/img/residence/old_4.JPG";
import res1 from "../../assets/img/residence/1_1.jpg";
import res2 from "../../assets/img/residence/1_2.jpg";
import res3 from "../../assets/img/residence/1_3.jpg";
import res4 from "../../assets/img/residence/1_4.jpg";
import res5 from "../../assets/img/residence/1_5.jpg";
import res6 from "../../assets/img/residence/1_6.jpg";
import res7 from "../../assets/img/residence/1_7.jpg";
import res8 from "../../assets/img/residence/1_8.jpg";
import res9 from "../../assets/img/residence/1_9.jpg";
import res10 from "../../assets/img/residence/1_10.jpg";
import res11 from "../../assets/img/residence/1_11.jpg";
import res12 from "../../assets/img/residence/1_12.jpg";
import res13 from "../../assets/img/residence/1_13.jpg";
import res14 from "../../assets/img/residence/1_14.jpg";
import res15 from "../../assets/img/residence/1_15.jpg";
import res16 from "../../assets/img/residence/1_16.jpg";
import res17 from "../../assets/img/residence/1_17.jpg";
import tech1 from "../../assets/img/residence/2_1.jpg";
import tech2 from "../../assets/img/residence/2_2.jpg";
import tech3 from "../../assets/img/residence/2_3.jpg";
import tech4 from "../../assets/img/residence/2_4.jpg";
import tech5 from "../../assets/img/residence/2_5.jpg";
import tech6 from "../../assets/img/residence/2_6.jpg";
import tech7 from "../../assets/img/residence/2_7.jpg";
import plants1 from "../../assets/img/residence/3_1.jpg";
import plants2 from "../../assets/img/residence/3_2.jpg";
import plants3 from "../../assets/img/residence/3_3.jpg";
import plants4 from "../../assets/img/residence/3_4.jpg";
import plants5 from "../../assets/img/residence/3_5.jpg";
import plants6 from "../../assets/img/residence/3_6.jpg";
import plants7 from "../../assets/img/residence/3_7.jpg";
import plants8 from "../../assets/img/residence/3_8.jpg";
import plants9 from "../../assets/img/residence/3_9.jpg";
import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../i18n";

const Residence = () => {
  const legendsRef = useRef(null);
  const rulesRef = useRef(null);
  const tourRef = useRef(null);
  const historyRef = useRef(null);
  const residenceRef = useRef(null);

  const [historySlide, setHistorySlide] = useState(0);
  const historyImages = [old1, old2, old3, old4];

  const user = useSelector((state) => state.user.data);


  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  const nextSlide = () => {
    setHistorySlide((prev) => (prev + 1) % historyImages.length);
  };
  const prevSlide = () => {
    setHistorySlide((prev) => (prev - 1 + historyImages.length) % historyImages.length);
  };

  const [residenceSlide, setResidenceSlide] = useState(0);
  const residenceImages = [
    res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11, res12, res13, res14, res15, res16, res17
  ];

  const nextResidenceSlide = () => {
    setResidenceSlide((prev) => (prev + 1) % residenceImages.length);
  };
  const prevResidenceSlide = () => {
    setResidenceSlide((prev) => (prev - 1 + residenceImages.length) % residenceImages.length);
  };

  const [techSlide, setTechSlide] = useState(0);
  const techImages = [
    tech1, tech2, tech3, tech4, tech5, tech6, tech7
  ];

  const nextTechSlide = () => {
    setTechSlide((prev) => (prev + 1) % techImages.length);
  };
  const prevTechSlide = () => {
    setTechSlide((prev) => (prev - 1 + techImages.length) % techImages.length);
  };

  const [plantsSlide, setPlantsSlide] = useState(0);
  const plantsImages = [
    plants1, plants2, plants3, plants4, plants5, plants6, plants7, plants8, plants9
  ];

  const nextPlantsSlide = () => {
    setPlantsSlide((prev) => (prev + 1) % plantsImages.length);
  };
  const prevPlantsSlide = () => {
    setPlantsSlide((prev) => (prev - 1 + plantsImages.length) % plantsImages.length);
  };

  const scrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div className="res__header">
        {/* <p className="res__p" onClick={() => scrollTo(tourRef)}>
          Резиденция
        </p> */}
        <p className="res__p" onClick={() => scrollTo(residenceRef)}>
          {t.navResidence}
        </p>
        <p className="res__p" onClick={() => scrollTo(historyRef)}>
          {t.navHistory}
        </p>
        <p className="res__p" onClick={() => scrollTo(legendsRef)}>
          {t.navLegend}
        </p>
        <p className="res__p" onClick={() => scrollTo(rulesRef)}>
          {t.navRules}
        </p>
      </div>

      <div className="res__contents">
        <div className="res__content" ref={tourRef}>
          {/* <h2>Экскурсия</h2> */}
          <div className="res__video-wrapper">
            <video
              controls
              playsInline
              preload="metadata"
              poster={videoPoster}
              width="100%"
              height="100%"
              style={{
                borderRadius: "8px",
                objectFit: "cover",
                background: "none",
              }}
            >
              <source src="/video/video.mp4" type="video/mp4" />
              {t.videoUnsupported}
            </video>
          </div>
        </div>
        <div className="res__content" ref={residenceRef}>
          <h2 style={{ marginTop: "10px" }}><b>{t.residenceTitle}</b></h2>
          <div className="res__text">
            <p style={{ marginBottom: "10px" }}>
              {t.residenceP1}
            </p>
            <p style={{ marginBottom: "10px" }}>
              {t.residenceP2}
            </p>

            <div style={{ position: 'relative', width: '100%', aspectRatio: '3/4', marginTop: '10px', marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <img src={residenceImages[residenceSlide]} alt="Interior" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

              <button
                onClick={prevResidenceSlide}
                style={{
                  position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 1L1.5 8L8.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button
                onClick={nextResidenceSlide}
                style={{
                  position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 1L8.5 8L1.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <p style={{ marginBottom: "10px" }}>
              {t.residenceP3}
            </p>

            <div style={{ position: 'relative', width: '100%', aspectRatio: '3/4', marginTop: '10px', marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <img src={techImages[techSlide]} alt="Technique" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

              <button
                onClick={prevTechSlide}
                style={{
                  position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 1L1.5 8L8.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button
                onClick={nextTechSlide}
                style={{
                  position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 1L8.5 8L1.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <p style={{ marginBottom: "10px" }}>
              {t.residenceP4}
            </p>

            <div style={{ position: 'relative', width: '100%', aspectRatio: '3/4', marginTop: '10px', marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <img src={plantsImages[plantsSlide]} alt="Plants and Details" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

              <button
                onClick={prevPlantsSlide}
                style={{
                  position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 1L1.5 8L8.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button
                onClick={nextPlantsSlide}
                style={{
                  position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 1L8.5 8L1.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <p>
              {t.residenceP5}
            </p>
          </div>
        </div>
        <div className="res__content" ref={historyRef}>
          <h2 style={{ marginTop: "30px" }}><b>{t.historyTitle}</b></h2>
          <div className="res__text">
            <img
              src={residenceImg}
              alt="Residence History"
              style={{
                width: "100%",
                borderRadius: "8px",
                marginTop: "0px",
                display: "block",
              }}
            />
            <p style={{ marginTop: "10px" }}>
              {t.historyP1}
            </p>

            <div style={{ position: 'relative', width: '100%', aspectRatio: '4/3', marginTop: '10px', marginBottom: '10px', borderRadius: '8px', overflow: 'hidden' }}>
              <img src={historyImages[historySlide]} alt="History" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

              <button
                onClick={prevSlide}
                style={{
                  position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 1L1.5 8L8.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button
                onClick={nextSlide}
                style={{
                  position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)',
                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '30px', height: '30px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white'
                }}
              >
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 1L8.5 8L1.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <p style={{ marginBottom: "10px" }}>
              {t.historyP2}
            </p>
            <div className="res__video-wrapper" style={{ aspectRatio: "9/16", marginTop: "10px", marginBottom: "10px" }}>
              <video
                controls
                playsInline
                preload="metadata"
                poster={historyVideoPoster}
                width="100%"
                height="100%"
                style={{
                  borderRadius: "8px",
                  objectFit: "cover",
                  background: "black",
                }}
              >
                <source src="/video/hist_vid.mp4" type="video/mp4" />
                {t.videoUnsupported}
              </video>
            </div>
            <p style={{ marginBottom: "10px" }}>
              {t.historyP3}
            </p>
            <p style={{ marginBottom: "10px" }}>
              {t.historyP4}
            </p>
            <p>
              {t.historyP5}
            </p>
            <p style={{ marginTop: "10px" }}>
              {t.historyP6}
            </p>
          </div>
        </div>
        <div className="res__content" ref={legendsRef}>
          <h2 style={{ marginTop: "30px" }}><b>{t.legendTitle}</b></h2>
          <div className="res__text">
            <p style={{ marginBottom: "10px" }}>
              {t.legendP1}
            </p>
            <p>
              {t.legendP2}
            </p>
          </div>
        </div>

        <div className="res__content" ref={rulesRef}>
          {/* <CachedImg src={vinilImg} alt="res" /> */}
          <h2 style={{ marginTop: "30px" }}><b>{t.rulesTitle}</b></h2>
          <div className="res__text">
            <p>
              {t.rulesIntro}
            </p>
            <ul style={{ margin: "10px 0px" }}>
              <li>{t.rulesLi1}</li>
              <li>
                {t.rulesLi2}
              </li>
              <li>{t.rulesLi3}</li>
              <li>{t.rulesLi4}</li>
              <li>{t.rulesLi5}</li>
              <li>{t.rulesLi6}</li>
            </ul>
            <p>{t.rulesOutro}</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Residence;
